import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-list',
  templateUrl: './error-list.component.html',
  styleUrl: './error-list.component.scss',
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class ErrorListComponent {
  errorMessages = input.required<string[]>();
}
